import { connect } from 'react-redux';

import StatusBanner from '../components/StatusBanner';

import { redirectSecureEdge, generateMigrateLink } from '../actions/account';

const mapStateToProps = (state, ownProps) => ({
  accountId: state.account.selected,
  hasSecureEdgeFeature: state.account.features.includes('secure_edge') || false,
  readOnlyDate: state.account.readOnlyDate,
  readOnlyState: state.account.readOnlyState || false,
  migrateRedirect: state.account.migrateLink || '',
  isMigrated: state.account.migrate_to_secure_edge || false,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  redirectSecureEdge: () => {
    dispatch(redirectSecureEdge());
  },
  generateMigrateLink: params => {
    dispatch(generateMigrateLink(params));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StatusBanner);
